import { observer } from 'mobx-react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ParticipantResource } from '../../../../ParticipantsStore/Types';
import ClickableTooltip from '../../../ClickableTooltip';
import { T } from '../../../../Translations';

interface Props {
  resource: ParticipantResource;
}

function InactiveIcon({ resource }: Props) {
  switch (resource.payload.status) {
    case 'active':
      return <></>;
    case 'disabled':
      return (
        <ClickableTooltip
          className="ml-1 flex w-1/2 text-center"
          tooltipId={'invitations'}
          tooltipIcon={<ExclamationTriangleIcon className="h-4 w-4" aria-hidden="true" />}
        >
          <T kind="Participant is no longer with the company" />
        </ClickableTooltip>
      );
  }
}

export default observer(InactiveIcon);
